import {
  H1,
  Paragraph,
  YStack,
  Image,
  Stack,
  styled,
  useMedia,
  GetProps,
  Unspaced,
  ParagraphProps,
} from '@mythical/ui'
import React from 'react'

const SectionIntroWrapper = styled(YStack, {
  width: '100%',
  ai: 'center',
  px: '$3',
  pt: '$4',
  space: '$2',
  jc: 'center',
  bg: '$secondary10',
  $gtXs: {
    px: '$2',
    pt: '$5',
    space: '$3',
  },
})

type SectionIntroWrapperProps = GetProps<typeof SectionIntroWrapper>

type SectionIntroProps = {
  title: string
  description?: string
  headingProps?: ParagraphProps
} & SectionIntroWrapperProps

const SectionIntro = ({
  title,
  description,
  headingProps,
  ...props
}: SectionIntroProps) => {
  const media = useMedia()
  return (
    <SectionIntroWrapper {...props}>
      <H1
        size="$8"
        maxWidth={700}
        mx="auto"
        color="$primary1"
        textTransform="uppercase"
        textAlign="center"
        fontWeight="700"
        $gtXs={{
          size: '$10',
          fontWeight: '700',
        }}
        {...headingProps}
      >
        {title}
      </H1>

      {media.gtMd && (
        <Unspaced>
          <Stack top="$0" right="$0" zIndex="$1" position="absolute">
            <Image
              height={80}
              width={90}
              source={require('../../../assets/images/serpent1.png')}
            />
          </Stack>
        </Unspaced>
      )}

      {description && (
        <Paragraph
          size="$3"
          textAlign="center"
          maxWidth={700}
          mx="auto"
          $gtXs={{
            size: '$6',
          }}
          color="$primary10"
        >
          {description}
        </Paragraph>
      )}
    </SectionIntroWrapper>
  )
}

export default SectionIntroWrapper.extractable(SectionIntro)
